import type { GraphQLTaggedNode } from 'react-relay';

import { expValEquals } from '@confluence/feature-experiments';

import { CollabDraftWithRelevanceQuery } from './CollabDraftWithRelevanceQuery.graphql.ts';
import { CollabDraftQuery } from './CollabDraftQuery.graphql.ts';

export const getCollabDraftQuery = (): GraphQLTaggedNode =>
	expValEquals('platform_editor_early_exit_return_draft', 'isEnabled', true)
		? CollabDraftWithRelevanceQuery
		: CollabDraftQuery;
